<template>
  <div class="side-menu prev">
    <ul class="list-group custom-inline-box">
      <li class="list-group-item active"><span style="margin-top: 5px; display: inline-block;">Typology</span>    <a @click="$bvModal.show('modal-arial-view')" href="javascript:void(0)" class="btn-aerial">Watch Aerial View</a></li>
      <li class="list-group-item list-group-item-action" v-for="typology in typologies">
        <div class="custom-control custom-radio">
          <input type="checkbox" :id="typology.key" name="typologySelector" class="check_class custom-control-input" @click="selectTypology(typology)" :checked="selectedTypology !== null && typology.key === selectedTypology.key">
          <label class="custom-control-label" :for="typology.key">{{typology.value}}  <div class="text-muted small">{{typology.area}}  Sq.Ft  </div></label>
          <div class="price-holder price-holder-a" :class="{'hidden-default' : typology.key !== selectedTypology.key}">
            <span class="title">Price Range</span>
            <span class="price">₹ {{typology.priceRange}} Cr</span>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <p class="small">*Price includes GST, Stamp Duty, Registration charges. It does not include Maintenance.</p>
        <div class="mbtn-align">
      
          <button type="button" class="btn btn-primary nextButton" :disabled="!selectedTypology.key">Next</button>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import {masterJson} from '@/assets/scripts/utility.js'
export default {
  methods: {
    selectTypology(typology){
      this.$store.dispatch('setTypology', typology);
    }
  },
  computed: {
    typologies(){
      return masterJson.Typologies
    },
    selectedTypology(){
      return this.$store.getters.selectedTypology;
    }
  }
}
</script>